<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-05 16:31:19
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-02 19:26:21
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\titleCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="statusCell flex-row flex-align-center">
		<div :class="['state-icon', statusData.style]"> </div>
		<span class="ml-4">{{ statusData.label }}</span>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	computed: {
		statusData({ row, column }) {
			const obj = {
				0: {
					label: '未绑定',
					style: 'warning',
				},
				1: {
					label: '已绑定',
					style: 'success',
				},
			};
			return obj[row[column.key]] || {};
		},
	},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped>
.state-icon {
	width: 6px;
	height: 6px;
	border-radius: 6px;
}
.success {
	background-color: @color-success;
}
.warning {
	background-color: @color-warning;
}
</style>
